import { Authenticable, GetAdminResponse, PermissionResponse, RoleResponse } from '../CRM/Responses/AdminResponse';

import Model from './Model';

export default class Admin extends Model implements Authenticable {
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly password: string;
    readonly remember_token: string | null;
    readonly reseller_percent_revenue: number;
    readonly default_resellers_max_debit: number | null;
    readonly aff_percent_revenue: number;
    readonly ggr_aff_percent_revenue: number;
    readonly casino_aff_percent_revenue: number;
    readonly created_at: string | null;
    readonly updated_at: string | null;
    readonly state: string | null;
    readonly country: string | null;
    readonly roles: Array<RoleResponse>;
    readonly permissions: Array<PermissionResponse>;
    // additional props
    readonly default_resellers_max_debit_formatted: string | null;

    constructor(admin: Partial<GetAdminResponse>) {
        super();
        this.assignDataToProps(admin, [
            'id',
            'name',
            'email',
            'password',
            'remember_token',
            'reseller_percent_revenue',
            'default_resellers_max_debit',
            'aff_percent_revenue',
            'ggr_aff_percent_revenue',
            'casino_aff_percent_revenue',
            'created_at',
            'updated_at',
            'state',
            'country',
            'roles',
            'permissions',
            'default_resellers_max_debit_formatted',
        ]);
    }
}
